/**
 * StatsPage — the Activity Stats page. Thin wrapper around the shared
 * <ActivityStats> component; the "whose" selection is URL-controlled (App owns
 * ?rep=), consistent with the ?tab= / follow-ups view model.
 */

import React from 'react';
import { ActivityStats } from './ActivityStats';

interface StatsPageProps {
  rep: string;                        // '' = role default (admin: all, rep: self)
  onChangeRep: (rep: string) => void; // writes ?rep= to the URL
}

export function StatsPage({ rep, onChangeRep }: StatsPageProps) {
  return (
    <div style={{ padding: '16px', flex: 1, overflowY: 'auto' }}>
      <h1 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '8px' }}>Activity Stats</h1>
      <p style={{ fontSize: '11px', color: 'var(--crm-dim)', marginBottom: '16px' }}>
        Calls and texts from the chips on a sales note · emails counted automatically from outbound client mail
      </p>
      <ActivityStats rep={rep} onChangeRep={onChangeRep} />
    </div>
  );
}
